import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Comparison = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.6468 8C14.6468 9.96 13.7935 11.7333 12.4335 12.94C11.2602 14.0067 9.70685 14.6467 8.00018 14.6467C4.33352 14.6467 1.35352 11.6667 1.35352 8C1.35352 4.33333 4.33352 1.35333 8.00018 1.35333C9.70685 1.35333 11.2602 1.99333 12.4335 3.06C13.7935 4.26667 14.6468 6.04 14.6468 8Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.97986 10.9267C7.96652 12.0267 7.14652 12.2933 6.37986 11.9867C4.79986 11.3533 3.68652 9.80666 3.68652 8C3.68652 6.19333 4.79986 4.64666 6.37986 4.00666C7.14652 3.7 7.96652 3.97333 7.97986 5.06666V10.9267Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Comparison.displayName = 'Comparison';
